import { Select } from "antd"
import { useState, useEffect } from 'react'
import req from '../request'

const App = props => {
    const [options, setOptions] = useState([{label:'a',value:'a'}])
    const getOptions = () => [
        req.post('/api/project',{action:'getProjects'}).then(r=>{
            setOptions(r)
        })
    ]
    const handleChange = t => {
        props.onChange && props.onChange(t)
    }
    useEffect(()=>{
        getOptions()
    },[])
    return <Select 
            allowClear
            showSearch
            value={props.value ? props.value : null} 
            style={{ width: 200 }} 
            placeholder='请选择项目' 
            options={options}
            onChange={handleChange}
            filterOption={(input, option) =>{
                return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }}
        >
    </Select>
}

export default App